import getFieldValue from '../elements/getFieldValue';
import getForm from '../elements/getForm';

function getFormUrl(email) {
  return `https://${process.env.API_HOST}/v1/learn-lab/users/exists?email=${encodeURIComponent(email)}`;
}

export default async function checkEmail(step) {
  const form = getForm(step);
  const email = getFieldValue(form, 'email');
  const url = getFormUrl(email);
  return fetch(url)
    .then((response) => {
      if(String(response.status).slice(0, 2) === '20') {
        throw new Error('Email already exists');
      }
    });
}
